import React from "react";

type Props = { children: React.ReactNode };
type State = { error: Error | null; componentStack: string | null };

export class ErrorBoundary extends React.Component<Props, State> {
    state: State = { error: null, componentStack: null };

    static getDerivedStateFromError(error: Error): Partial<State> {
        return { error };
    }

    componentDidCatch(error: Error, info: React.ErrorInfo) {
        this.setState({ error, componentStack: info.componentStack ?? null });
        console.error("Unhandled React error:", error, info.componentStack);
    }

    render() {
        const { error, componentStack } = this.state;
        if (!error) {
            return this.props.children;
        }

        return (
            <div style={{ padding: "24px", fontFamily: "monospace", color: "#a80000", background: "#fff", overflow: "auto" }}>
                <h2>Something went wrong</h2>
                <p>
                    <b>{error.name}:</b> {error.message}
                </p>
                <pre style={{ whiteSpace: "pre-wrap" }}>{error.stack}</pre>
                {componentStack && (
                    <>
                        <h3>Component stack</h3>
                        <pre style={{ whiteSpace: "pre-wrap" }}>{componentStack}</pre>
                    </>
                )}
            </div>
        );
    }
}

export default ErrorBoundary;
